import AuthCore from './core'
// import { GTM } from './features/gtm'

export const auth = new AuthCore()
// export const gtm = new GTM()

export default { auth }
